import { TranslationKeyLanguages } from '../../model';

export const sortTranslationsBasedOnKey = (translationArray: Array<TranslationKeyLanguages>): Array<TranslationKeyLanguages> => {
  return translationArray.sort((a, b) => a.key.localeCompare(b.key));
};
